<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3">
<h1 class="title">NAPOLEON’S IMPERIAL GUARD UNIFORMS AND EQUIPMENT</h1>
<p class="suba-title">THE CAVALRY</p>
<p class="author">PAUL L. DAWSON</p>
<p class="authora">COLOUR PLATES BY KEITH ROCCO</p>
<div class="pub"><img alt="image" src="images/pub.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?11c01488